import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import moment from 'moment';
import constClass from '../../Constants/Constants';

const PointHistory = ({ siteId, liffAccessToken, mallId }) => {
  const [historyData, setHistoryData] = useState(null);
  const refreshData = useCallback(async () => {
    try {
      //各データ取得APIを先に実行
      const history = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/line/history/`, { site_id: siteId, line_id: liffAccessToken, mall_id: mallId })).data;
      const merged = [];
      const seen = new Set();

      history.data.forEach(item => {
        if (item.point_type === 4) {
          const dateKey = moment(item.history_date).format('YYYY-MM-DD');
          if (!seen[dateKey]) {            
            seen[dateKey] = { ...item, point: Number(item.point) };
            merged.push(seen[dateKey]);
          } else {
            seen[dateKey].point += Number(item.point);
          }
        } else {
          merged.push(item);
        }
      });
      const filterHistory = merged.filter(item => item.ticket_type !== constClass.FLAG.OFF && item.point >= 0);
      setHistoryData(filterHistory);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, liffAccessToken, mallId]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  return (
    <div id="membershippass" className="point-history">
      <div className='point-history-text'>
        ポイント履歴
      </div>
      <div className='frame94'>
        <div className='frame92'>
          <div className='frame81'>
            <div className='point-date'>日付</div>
          </div>
          <div className='frame79'>
            <div className='frame77'>
              <div className='point-detail'>内容</div>
              <div className='point-use-shop'>ご利用店舗</div>
            </div>
          </div>
          <div className='frame80'>
            <div className='point-text'>ポイント</div>
          </div>
        </div>
        {historyData && historyData.length > 0 ?
          historyData.map((item, index) => (
            <React.Fragment key={index}>
              <div className='frame93'>
                <div className='frame79'>
                  <div className='frame81'>
                    <div className='point-date-text'>{moment(item.history_date).format('YYYY/MM/DD')}</div>
                  </div>
                  <div className='frame79'>
                    <div className='frame77'>
                      <div className='point-detail-text'>
                        {item.remarks && <div className=''> {item.remarks}</div>}
                        {item.returns_type ? (
                          <div className=''>
                            {moment(item.point_date).format('YYYY/MM/DD')} {constClass.RETURNS_TYPE_NAME[item.returns_type]}
                          </div>
                        ) : (item.use_point || item.expire_point) ? (
                          ""
                        ) : (item.point_type && item.point_type.toString() === constClass.POINT_TYPE.FIRST.toString()) ? (
                          <div className=''>初回登録特典</div>
                        ) : item.point_type === 4 ? (
                          <div className=''>ランクアップポイント</div>
                        ) : (
                          <div className=''>
                            ポイント付与{Number(item.amount) > 0 && `(${item.amount.toLocaleString()}円)`}
                          </div>
                        )}
                      </div>
                      {item.point_type !== 4 &&
                        <div className='point-use-shop-text'>{item.shop_name ? item.shop_name : ""}{item.mall_name ? `(${item.mall_name})` : ""}</div>
                      }
                    </div>
                  </div>
                  <div className='frame80'>
                    <div className={item.expire_point ? 'point-minus-value-text' : item.use_point ? 'point-minus-value-text' : 'point-plus-value-text'}>
                      {item.expire_point ? <><span>-  {item.expire_point.toLocaleString()}</span> <span className='pt-minus-text'>pt</span></> : item.use_point ? <><span>-  {item.use_point.toLocaleString()}</span> <span className='pt-minus-text'>pt</span></> : item.point ? <><span>+  {item.point.toLocaleString()}</span> <span className='pt-plus-text'>pt</span></> : "-"}
                    </div>
                  </div>
                </div>
              </div>
              <div className='vector17'></div>
            </React.Fragment>
          )) : <div colSpan={3} className='p-2 text-center mt-4'>履歴がありませんでした</div>}
      </div>
    </div>
  );
};

export default PointHistory;